// extracted by mini-css-extract-plugin
export default {"box":"Company_box__LdoL7","form":"Company_form__r0-6E","actions":"Company_actions__c6Z93","title":"Company_title__QWa1P","btn":"Company_btn__P6Cd4"};